import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";
import task05 from "./layouts/task-05/task";
import task06 from "./layouts/task-06/task";

const lesson: Lesson = {
  id: "2ce4d57e-3ac8-49fc-b924-aad5b027d324",
  publicId: "4",
  name: "Fourier transform",
  body: [principle01, task01, task02, task03, task04, task05, task06],
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
};

export default lesson;
